import React from 'react';
import PropTypes from 'prop-types';
import FlipMove from 'react-flip-move';

import { CREATOR_REPORTS_NOTEWORTHY } from '../../constants';

import ResponsesList from './ResponsesList';
import NoteworthySelectionDialog from './NoteworthySelectionDialog';

class NoteworthySection extends React.PureComponent {
  render() {
    const {
      event,
      editing,
      isPdfRender,
      isNoteworthyResponsesEnabled,
      isNoteworthyResponsesVisuallyEnabled,
      noteworthyPosts,
      showNoteworthyDialog,
      handleNoteworthyEditClicked,
      handleNoteworthySwitchChanged,
      onReArrangedNoteworthyPosts,
      getScrollingOffsetDistance,
      onHideNoteworthyDialog,
      onReceivedNoteworthyPosts,
    } = this.props;

    if (!isNoteworthyResponsesEnabled) {
      return null;
    }

    return (
      <div
        className="section noteworthy-section"
        id={CREATOR_REPORTS_NOTEWORTHY}
      >
        <div className="section-header">
          <div className="section-title">
            Noteworthy Responses
          </div>
          <div className="section-actions">
            {editing && (
              <div className="edit-button-container">
                <button
                  className="edit-button"
                  onClick={handleNoteworthyEditClicked}
                >
                  Edit
                </button>
              </div>
            )}
            <div className="switch-container">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isNoteworthyResponsesVisuallyEnabled}
                  onChange={handleNoteworthySwitchChanged}
                />
                <span className="slider round" />
              </label>
            </div>
          </div>
        </div>
        {isNoteworthyResponsesVisuallyEnabled && (
          <div className="section-content">
            {isPdfRender ? (
              <div>
                {noteworthyPosts.map((response, index) => (
                  <ResponsesList
                    key={response.id}
                    response={response}
                    event={event}
                    index={index}
                    onReArranged={onReArrangedNoteworthyPosts}
                    getScrollingOffsetDistance={getScrollingOffsetDistance}
                  />
                ))}
              </div>
            ) : (
              <FlipMove
                duration={750}
                easing="ease-out"
                onStart={() => {
                  // Fix for react-flip-move and scrolling
                  // https://github.com/joshwcomeau/react-flip-move/issues/112
                  const html = document.getElementsByTagName('html')[0];
                  html.style.scrollBehavior = 'auto';
                }}
                onFinish={() => {
                  const html = document.getElementsByTagName('html')[0];
                  html.style.scrollBehavior = 'smooth';
                }}
              >
                {noteworthyPosts.map((response, index) => (
                  <ResponsesList
                    key={response.id}
                    response={response}
                    event={event}
                    index={index}
                    onReArranged={onReArrangedNoteworthyPosts}
                    getScrollingOffsetDistance={getScrollingOffsetDistance}
                  />
                ))}
              </FlipMove>
            )}
          </div>
        )}

        {showNoteworthyDialog && (
          <NoteworthySelectionDialog
            onHidden={onHideNoteworthyDialog}
            onReceivedNoteworthyPosts={onReceivedNoteworthyPosts}
            event={event}
            noteworthyPosts={noteworthyPosts}
          />
        )}
      </div>
    );
  }
}

NoteworthySection.propTypes = {
  event: PropTypes.object.isRequired,
  editing: PropTypes.bool.isRequired,
  isPdfRender: PropTypes.bool,
  isNoteworthyResponsesEnabled: PropTypes.bool.isRequired,
  isNoteworthyResponsesVisuallyEnabled: PropTypes.bool.isRequired,
  noteworthyPosts: PropTypes.array.isRequired,
  showNoteworthyDialog: PropTypes.bool.isRequired,
  handleNoteworthyEditClicked: PropTypes.func.isRequired,
  handleNoteworthySwitchChanged: PropTypes.func.isRequired,
  onReArrangedNoteworthyPosts: PropTypes.func.isRequired,
  getScrollingOffsetDistance: PropTypes.func.isRequired,
  onHideNoteworthyDialog: PropTypes.func.isRequired,
  onReceivedNoteworthyPosts: PropTypes.func.isRequired,
};

export default NoteworthySection;
